import type { AxiosResponse } from 'axios';

interface GenerateProps {
  locationId?: string;
  serviceId?: string;
  preferredLang?: string;
  preferredStaffId?: string;
  language?: string;
  walkIn?: boolean;
}

export const QrCode = (client) => ({
  generate({
    locationId,
    serviceId,
    preferredLang,
    preferredStaffId,
    language,
    walkIn,
  }: GenerateProps): Promise<AxiosResponse<unknown>> {
    const params: Record<string, string | boolean> = {};

    if (locationId) {
      params['location_id'] = locationId;
    }
    if (serviceId) {
      params['service_id'] = serviceId;
    }
    if (preferredLang) {
      params['preferred_lang'] = preferredLang;
    }
    if (preferredStaffId) {
      params['preferred_staff_id'] = preferredStaffId;
    }
    if (language) {
      params['language'] = language;
    }
    if (walkIn) {
      params['walk_in'] = walkIn;
    }

    const query = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
      )
      .join('&');

    return client.get(`/api/v3/open/qr${query ? `?${query}` : ''}`);
  },
});
